import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom"; 
import Logo from "../assets/icons/Logo.png";
import MenuIcon from "../assets/icons/menu.png";
import CloseIcon from "../assets/icons/close.png";
import { 
  HeaderContainer, 
  LogoContainer, 
  LogoImage, 
  NavMenu, 
  NavItem, 
  ButtonContainer, 
  StyledButton, 
  MobileMenuIcon, 
  MobileDrawer, 
  CloseButton, 
  MobileNavLinks, 
  MobileStyledButton, 
  MobileLogoImage
} from "../assets/styles/HeaderStyles";

const Header = ({ departmentsRef, solutionsRef, resourcesRef }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const location = useLocation(); 
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      const sections = [
        { ref: departmentsRef, id: "Departments" },
        { ref: solutionsRef, id: "Solutions" },
        { ref: resourcesRef, id: "Resources" },
      ];

      let currentActiveLink = "";

      sections.forEach((section) => {
        if (section.ref.current) {
          const sectionTop = section.ref.current.offsetTop;
          const sectionBottom = sectionTop + section.ref.current.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            currentActiveLink = section.id;
          }
        }
      });

      setActiveLink(currentActiveLink);
    };

    if (location.pathname === "/") {
      window.addEventListener("scroll", handleScroll);
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, [departmentsRef, solutionsRef, resourcesRef, location.pathname]);

  useEffect(() => {
    const path = location.pathname.toLowerCase();
  
    if (path === "/about-us") {
      setActiveLink("About Us"); 
    } else if (path.includes("/departments")) {
      setActiveLink("Departments");
    } else if (path.includes("/solutions")) {
      setActiveLink("Solutions");
    } else if (path === "/") {
      setActiveLink(""); 
    } else {
      setActiveLink(""); 
    }
  }, [location.pathname]);

  const handleScrollToSection = (ref) => {
    if (location.pathname !== "/") {
      navigate("/"); 
      setTimeout(() => {
        scrollToSection(ref);
      }, 500); 
    } else {
      scrollToSection(ref);
    }
  };

  const scrollToSection = (ref, offset = 90) => {
    if (ref && ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop - offset,
        behavior: "smooth",
      });
    } else {
      console.error("The ref is undefined or null", ref);
    }
  };

  const activeLinkStyle = {
    fontWeight: "600",
    color: "#1D00C4"
  };

  const defaultLinkStyle = {
    fontWeight: "normal",
    color: "inherit"
  };

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    window.scrollTo(0, 0);  
  }, [location]);

  return (
    <HeaderContainer>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <LogoContainer>
          <LogoImage src={Logo} alt="Logo" />
        </LogoContainer>
      </Link>

      <NavMenu>
        <NavItem
          to="/"
          onClick={() => handleScrollToSection(solutionsRef)}
          style={activeLink === "Solutions" ? activeLinkStyle : defaultLinkStyle}
        >
          Solutions
        </NavItem>
        <NavItem
          to="/"
          onClick={() => handleScrollToSection(departmentsRef)}
          style={activeLink === "Departments" ? activeLinkStyle : defaultLinkStyle}
        >
          Business Verticals
        </NavItem>
        <NavItem
          as={Link}  
          to="/about-us"
          onClick={() => navigate("/about-us")}
          style={activeLink === "About Us" ? activeLinkStyle : defaultLinkStyle}
        >
          About Us
        </NavItem>
      </NavMenu>

      <ButtonContainer>
        <StyledButton variant="contained" onClick={() => navigate("/contact-us")}>Get Demo</StyledButton>
      </ButtonContainer>

      <MobileMenuIcon
        src={MenuIcon}
        alt="Menu"
        onClick={() => setMenuOpen(true)}
      />

      <MobileDrawer open={menuOpen}>
        <CloseButton src={CloseIcon} alt="Close" onClick={() => setMenuOpen(false)} />
        <MobileLogoImage src={Logo} alt="Logo" />
        <MobileNavLinks>
          <NavItem
            to="/"
            onClick={() => {
              handleScrollToSection(solutionsRef);
              closeMenu();
            }}
            style={activeLink === "Solutions" ? activeLinkStyle : defaultLinkStyle}
          >
            Solutions
          </NavItem>
          <NavItem
            to="/"
            onClick={() => {
              handleScrollToSection(departmentsRef);
              closeMenu();
            }}
            style={activeLink === "Departments" ? activeLinkStyle : defaultLinkStyle}
          >
            Business Verticals
          </NavItem>
          <NavItem
            to="/about-us"
            onClick={() => {
              navigate("/about-us");
              closeMenu();
            }}
            style={activeLink === "About Us" ? activeLinkStyle : defaultLinkStyle}
          >
            About Us
          </NavItem>
          <MobileStyledButton variant="contained"  onClick={() => navigate("/contact-us")}>Get Demo</MobileStyledButton>
        </MobileNavLinks>
      </MobileDrawer>
    </HeaderContainer>
  );
};

export default Header;
